/**
  * Calculate distance in quilometers between the given coords
  * @param {*} lat1
  * @param {*} lon1
  * @param {*} lat2
  * @param {*} lon2
  * @returns distance in quilometers
  */
const calculateDistanceByCoords = (lat1, lon1, lat2, lon2) => {
  const toRad = (Value) => (Value * Math.PI) / 180;
  const R = 6371; // km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const lat1_ = toRad(lat1);
  const lat2_ = toRad(lat2);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
     + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1_) * Math.cos(lat2_);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;

  return d;
};

module.exports = {
  calculateDistanceByCoords,
};
